import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FileArchive, Users, Building, History, User2Icon, LogOut, MessageSquare, PlusCircle, X } from 'lucide-react';

const MobileMenu = ({ 
  mobileMenuOpen, 
  setMobileMenuOpen, 
  tabValue, 
  setTabValue, 
  currentUser, 
  handleLogout 
}) => {
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        duration: 0.4, 
        ease: "easeOut" 
      } 
    },
    exit: { 
      opacity: 0,
      transition: { 
        duration: 0.2,
        ease: "easeIn" 
      } 
    }
  };

  return (
    <AnimatePresence>
      {mobileMenuOpen && (
        <motion.div
          className="md:hidden fixed inset-0 z-40 pt-20 bg-gradient-to-br from-indigo-900/95 via-blue-800/95 to-indigo-900/95"
          variants={fadeIn}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          {/* Close button */}
          <motion.button
            className="absolute top-4 right-4 p-2 rounded-full bg-white/10 text-white hover:bg-white/20"
            onClick={() => setMobileMenuOpen(false)}
            whileTap={{ scale: 0.9 }}
          >
            <X className="h-6 w-6" />
          </motion.button>
          
          <div className="px-4 py-6 space-y-6">
            <div className="space-y-1">
              <button
                onClick={() => {
                  setTabValue(0);
                  setMobileMenuOpen(false);
                }}
                className={`flex w-full items-center px-3 py-3 rounded-xl ${
                  tabValue === 0 
                    ? 'bg-white/20 text-white' 
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                <FileArchive className="w-5 h-5 mr-3" />
                Reportes
              </button>

              <button
                onClick={() => {
                  setTabValue(1);
                  setMobileMenuOpen(false);
                }}
                className={`flex w-full items-center px-3 py-3 rounded-xl ${
                  tabValue === 1 
                    ? 'bg-white/20 text-white' 
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                <Users className="w-5 h-5 mr-3" />
                Usuarios
              </button>

              <button
                onClick={() => {
                  setTabValue(2);
                  setMobileMenuOpen(false);
                }}
                className={`flex w-full items-center px-3 py-3 rounded-xl ${
                  tabValue === 2 
                    ? 'bg-white/20 text-white' 
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                <Building className="w-5 h-5 mr-3" />
                Propiedades
              </button>

              <button
                onClick={() => {
                  setTabValue(3);
                  setMobileMenuOpen(false);
                }}
                className={`flex w-full items-center px-3 py-3 rounded-xl ${
                  tabValue === 3 
                    ? 'bg-white/20 text-white' 
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                <History className="w-5 h-5 mr-3" />
                Historial
              </button>
              
              <button
                onClick={() => {
                  setTabValue(4);
                  setMobileMenuOpen(false);
                }}
                className={`flex w-full items-center px-3 py-3 rounded-xl ${
                  tabValue === 4 
                    ? 'bg-white/20 text-white' 
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                <MessageSquare className="w-5 h-5 mr-3" />
                Contactos
              </button>
              
              <button
                onClick={() => {
                  setTabValue(5);
                  setMobileMenuOpen(false);
                }}
                className={`flex w-full items-center px-3 py-3 rounded-xl ${
                  tabValue === 5 
                    ? 'bg-white/20 text-white' 
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                <PlusCircle className="w-5 h-5 mr-3" />
                Registrar Constructora
              </button>
            </div>

            {/* User and logout */}
            <div className="border-t border-white/20 pt-6">
              <div className="flex items-center mb-6 text-white">
                <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-400 to-indigo-500 flex items-center justify-center mr-3">
                  <User2Icon className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="font-medium">{currentUser?.nombre || 'Staff'}</p>
                  <p className="text-sm text-white/70">Administrador</p>
                </div>
              </div>

              <button
                onClick={handleLogout}
                className="flex w-full items-center px-3 py-3 text-white bg-white/10 hover:bg-white/20 rounded-xl"
              >
                <LogOut className="w-5 h-5 mr-3" />
                Cerrar Sesión
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileMenu;